import { defineStore } from 'pinia';

export const useTableLayoutSettingsStore = defineStore('tableLayoutSettings', {
  state: () => ({
    stripedRows: false, // Zeilen mit abwechselnder Hintergrundfarbe
    cellGrid: true, // Zellenraster anzeigen oder nicht
    checkboxMultiselect: true, // Checkbox-Multiselect aktiviere
    footerPagination: false, // Zeige Pagination im Footer
    instantEdit: false, // Mit einem Klick i den Editmode
  }),
  actions: {
    setStripedRows(value: boolean) {
      this.stripedRows = value;
    },
    setCellGrid(value: boolean) {
      this.cellGrid = value;
    },
    setCheckboxMultiselect(value: boolean) {
      this.checkboxMultiselect = value;
    },
    setFooterPagination(value: boolean) {
      this.footerPagination = value;
    },
    setInstantEdit(value: boolean) {
      this.instantEdit = value;
    },
  },
  persist: {
    storage: localStorage,
  },
});
